'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z' });

var Tablet = function Tablet(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Tablet = (0, _pure2.default)(Tablet);
Tablet.muiName = 'SvgIcon';

exports.default = Tablet;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Tablet.js
// module id = 2923
// module chunks = 0